module.exports = __webpack_public_path__ + "static/media/Google.76f41c3b.svg";